{
    "onthejobtraining": {
        "Baslik": "On The Job Training",
        "Kullanici": "Gebruiker",
        "Musteri": "Klant",
        "Tarih": "Datum",
        "Durum": "Status",
        "Gorus": "Mening",
        "Not": "Notitie",
        "Degerlendirme": "Evaluatie",
        "RandevuDetayi": "Afspraak Detail",
        "RandevuTarihi": "Afspraak Datum",
        "RandevuSonucu": "Afspraak Resultaat",
        "Arama": "Zoeken",
        "Ara": "Zoeken",
        "Kapat": "Sluiten",
        "Temizle": "Wissen",
        "Kaydet": "Opslaan",
        "KaydetKapat": "Opslaan-Sluiten",
        "Bekliyor": "Wachten op Mening",
        "GorusAldi": "Antwoord Geschreven",
        "Tamamlandi": "Gesloten",
        "EminMisiniz": "Weet u het zeker?",
        "SilmeMesaj": "U kunt dit niet ongedaan maken!",
        "Hepsi": "Alle"
    }
}
